import React from 'react';

import PropTypes from 'prop-types';

import {
  PaginationWrapper,
  PaginationContainer,
  PageButtons,
  NaviagationButtons,
  NaviagationButtonText,
  ActivePage
} from './css';

const Pagination = ({
  pageNumber: currentPage,
  setPageNumber,
  ordersPerPage,
  totalOrders
}) => {
  const maxPages = 5;
  const totalPages = Math.ceil(totalOrders / ordersPerPage);

  const getPages = () => {
    let startPage;
    let endPage;

    if (totalPages <= maxPages) {
      startPage = 1;
      endPage = totalPages;
    } else {
      const maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
      const maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
      if (currentPage <= maxPagesBeforeCurrentPage) {
        startPage = 1;
        endPage = maxPages;
      } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
        startPage = totalPages - maxPages + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - maxPagesBeforeCurrentPage;
        endPage = currentPage + maxPagesAfterCurrentPage;
      }
    }

    const pages = Array.from(Array(endPage + 1 - startPage).keys()).map(
      i => startPage + i
    );
    return pages;
  };

  if (totalPages === 1) return null;

  return (
    <PaginationWrapper>
      <PaginationContainer>
        {currentPage > 1 && (
          <NaviagationButtons
            onClick={() => {
              setPageNumber(currentPage - 1);
            }}
          >
            <NaviagationButtonText>«</NaviagationButtonText>
          </NaviagationButtons>
        )}

        {getPages().map(pageNumber =>
          pageNumber === currentPage ? (
            <ActivePage
              onClick={() => {
                setPageNumber(pageNumber);
              }}
            >
              {pageNumber}
            </ActivePage>
          ) : (
            <PageButtons
              onClick={() => {
                setPageNumber(pageNumber);
              }}
            >
              {pageNumber}
            </PageButtons>
          )
        )}
        {currentPage < totalPages && (
          <NaviagationButtons
            onClick={() => {
              setPageNumber(currentPage + 1);
            }}
          >
            <NaviagationButtonText>»</NaviagationButtonText>
          </NaviagationButtons>
        )}
      </PaginationContainer>
    </PaginationWrapper>
  );
};

Pagination.propTypes = {
  ordersPerPage: PropTypes.number.isRequired,
  totalOrders: PropTypes.number.isRequired,
  pageNumber: PropTypes.number.isRequired,
  setPageNumber: PropTypes.func.isRequired
};

export default Pagination;
